module.exports = __webpack_public_path__ + "media/images/icons/twotone/html5-928c6eeedf7c565a54884ec9b5d31199.svg";